import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsKbRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-kb',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/kb',
	exact: true,
};
